// Copyright (c) 2016 Deere & Company

import EmissionsPartSearch from '@deere/cps-it.warranty-model-factory/lib/emissions-part-search';
import t from 'tcomb';

const Report = t.list(EmissionsPartSearch, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/emissions-part-search/state/report.js